<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.propertySetting.menu"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.propertySetting.list.title"></app-i18n>
      </h1>

      <app-property-setting-list-toolbar></app-property-setting-list-toolbar>
      <app-property-setting-list-filter></app-property-setting-list-filter>
      <app-property-setting-list-table></app-property-setting-list-table>
    </div>
  </div>
</template>

<script>
import PropertySettingListFilter from '@modules/property-setting/components/property-setting-list-filter.vue';
import PropertySettingListTable from '@modules/property-setting/components/property-setting-list-table.vue';
import PropertySettingListToolbar from '@modules/property-setting/components/property-setting-list-toolbar.vue';

export default {
  name: 'app-property-setting-list-page',

  components: {
    [PropertySettingListFilter.name]: PropertySettingListFilter,
    [PropertySettingListTable.name]: PropertySettingListTable,
    [PropertySettingListToolbar.name]: PropertySettingListToolbar,
  },
};
</script>

<style>
</style>
